<ion-app>
  @if (!sessionChecking && !insertPinRequired) {
    <ion-router-outlet></ion-router-outlet>
  } @else {
    @if (mode === "insert-pin") {
      <app-layout-auth class="block h-full">
        <div class="flex h-full flex-col items-center justify-center p-8">
          @if (insertPinRequired === null) {
            <div
              class="bg-bg-surface-default border-line-brand flex w-full flex-col items-center justify-center rounded-xl border p-8">
              <ic-ax-full class="mx-auto w-max" />
              <div class="flex gap-2 space-y-2 pt-12 pb-8">
                <p class="text-text-subtler text-sm">Memverifikasi akses...</p>
                <ic-spinner class="text-icon-brand block h-5 w-5 animate-spin" />
              </div>
            </div>
          } @else {
            <div
              template="mobile-hero"
              class="mx-auto max-w-60">
              <div class="flex flex-col items-center justify-center gap-6">
                <img
                  [src]="thumbnail.thumbnail_url"
                  class="h-16 w-16 rounded-lg"
                  alt="" />
                <div class="space-y-1 text-center">
                  <p class="font-montserrat text-text-default text-2xl">
                    {{ thumbnail.name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="space-y-10 p-6">
              <div class="space-y-2 text-center">
                <p class="text-text-default text-lg font-bold">Konfirmasi Pin</p>
                <p class="text-text-default text-sm">
                  Masukkan Pin sebelum masuk ke Sistem {{ thumbnail.name }}
                </p>
              </div>
              @if (profile) {
                <div
                  class="border-line-default mx-auto flex w-max items-center gap-2 rounded-full border p-2 pr-4">
                  <img
                    class="border-line-default h-9 w-9 rounded-full border object-cover"
                    [src]="profile.employee_info.image" />
                  <div>
                    <p class="text-text-default text-sm font-semibold">{{ profile.name }}</p>
                    <div class="flex items-center gap-1">
                      <p class="text-text-default text-xs">
                        {{ profile.employee_info.divisi?.code }}
                      </p>
                      <p class="text-text-default text-xs">&middot;</p>
                      <p class="text-text-default text-xs">
                        {{ profile.employee_info.jabatan?.name }}
                        {{
                          profile.employee_info.sub_divisi
                            ? profile.employee_info.sub_divisi.name
                            : profile.employee_info.divisi?.name
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              }
              <div class="space-y-3">
                <div class="flex items-center justify-center gap-2">
                  <p-inputOtp
                    class="block"
                    [(ngModel)]="pin"
                    [length]="pinLength"
                    [integerOnly]="true">
                    <ng-template
                      pTemplate="input"
                      let-token
                      let-events="events"
                      let-index="index">
                      <input
                        pInputText
                        type="text"
                        autocomplete="one-time-code"
                        class="text-text-brand border-line-default focus:border-line-brand focus:outline-line-brand h-10 w-10 rounded-xl border bg-transparent text-center text-2xl font-bold transition"
                        [pAutoFocus]="index === 0"
                        [ngClass]="{ 'text-text-error border-line-error': pinError }"
                        (input)="events.input($event)"
                        (keydown)="events.keydown($event)"
                        (paste)="onPaste($event)"
                        [type]="pinType"
                        [attr.value]="token"
                        [maxLength]="1" />
                    </ng-template>
                  </p-inputOtp>
                  <app-button
                    theme="transparent"
                    styleClass="!h-10 rounded-lg"
                    [icon]="true"
                    (click)="onTogglePinType()">
                    @if (pinType === "password") {
                      <ic-eye-on-outline class="block h-5 w-5" />
                    } @else {
                      <ic-eye-off-outline class="block h-5 w-5" />
                    }
                  </app-button>
                </div>
                <app-button
                  class="mx-auto block"
                  [disabled]="pinSubmitting"
                  (click)="onSubmit()">
                  Submit
                </app-button>
              </div>
              <div class="space-y-3">
                <button
                  class="text-text-default mx-auto flex w-max items-center gap-2 text-sm"
                  (click)="mode = 'forget-pin'">
                  Lupa pin?
                  <span class="text-text-brand underline underline-offset-4">
                    Atur ulang pin disini
                  </span>
                </button>
                <button
                  class="text-text-brand mx-auto flex w-max items-center gap-2 text-sm"
                  (click)="authService.logout()">
                  <ic-arrow-left-outline class="block h-3 w-3" />
                  <span class="underline underline-offset-4"> Kembali Ke Abang Kerja </span>
                </button>
              </div>
            </div>
          }
        </div>
      </app-layout-auth>
    } @else {
      <app-forgot-pin
        class="block h-full"
        (back)="mode = 'insert-pin'" />
    }
  }
</ion-app>

<dialog-coming-soon />
<dialog-loading />
<dialog-image-preview />

<app-toast />
